import React, { useContext, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
  getDate,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const GatePassAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  //getting context values here
  let {
    loading,
    setLoading,
    branchForSearch,
    branchForListSearch,
    ingredientItemForSearch,
  } = useContext(RestaurantContext);

  let { authUserInfo } = useContext(UserContext);

  // States hook here
  const [branchSearch, setBranchSearch] = useState(null);
  //new item
  let [newGatePass, setNewGatePass] = useState({
    documentDate: new Date(),
    identity: "",
    taker_name: "",
    branch: null,
    type: "temporary",
    remarks: "",
  });

  let common_toast = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  //new Row
  const [newRow, setNewRow] = useState([]);

  const getGatePass = async () => {
    try {
      setLoading(true)
      const url = BASE_URL + "/settings/gate-pass/" + id;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        setLoading(false);
        const date = new Date(res.data.document_date);
        setNewGatePass({
          identity: res.data.document_identity,
          documentDate: date,
          taker_name: res.data.taker_name,
          branch: {
            id: res.data.branch_id,
            name: res.data.branch_name,
          },
          type: res.data.type,
          remarks: res.data.remarks,
        });
        const passDetail = res.data.gate_pass_details.map((item) => {
          return {
            ...item,
            isEdit: true,
          };
        });
        setNewRow([...passDetail]);
      }
    } catch (err) {
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`, common_toast);
    }
  };

  useEffect(() => {
    if (
      authUserInfo.details.user_type === "manager" ||
      authUserInfo.details.user_type === "staff"
    ) {
      setBranchSearch([branchForListSearch[authUserInfo.details.branch_id]]);
    } else {
      setBranchSearch(branchForSearch);
    }
  }, [branchForSearch]);

  useEffect(() => {
    if (id) {
      getGatePass();
    }
  }, [id]);

  const handleSetPass = (e) => {
    setNewGatePass({ ...newGatePass, [e.target.name]: e.target.value });
  };

  //handle Set branch hook
  const handleSetBranch = (branch) => {
    setNewGatePass({ ...newGatePass, branch });
  };

  //set each item qty
  const handleQty = (index, e) => {
    newRow[index].qty = e.target.value;
    setNewRow([...newRow]);
  };

  const handleSetItems = (index, item) => {
    newRow[index].item_name = item;
    setNewRow([...newRow]);
  };

  //post req of stock item add
  const gatePassAxios = async (formData) => {
    setLoading(true);
    const endPoint = id ? `/settings/gate-pass/${id}` : "/settings/gate-pass";
    const url = BASE_URL + endPoint;
    try {
      const method = id ? "put" : "post";
      const res = await axios[method](url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        setLoading(false);
        toast.success(
          `${_t(
            t(id ? "Gate pass has been updated" : "Gate pass has been added")
          )}`,
          common_toast
        );
        history.push("/dashboard/manage/stock/gate-pass");
      }
    } catch (error) {
      setLoading(false);
      toast.error(`${_t(t("Please try again later"))}`, common_toast);
    }
  };

  //send to server
  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      newRow !== null &&
      newRow.length > 0 &&
      newGatePass.documentDate &&
      newGatePass.branch
    ) {
      let duplicate = {};
      const duplicateItem = [];
      const tableArr = [];
      newRow.forEach((item) => {
        if (duplicate[item?.item_id || item.item_name?.id]) {
          duplicateItem.push({
            item_id: item?.item_id || item.item_name.id,
            item_name: item.item_name?.name || item.item_name,  
          });
        }
        duplicate[item?.item_id || item.item_name?.id] = true;
        if (item.item_name) {
          tableArr.push({
            item_id: item.isEdit ? item.item_id : item.item_name.id,
            item_name: item.isEdit ? item.item_name : item.item_name.name,
            qty: item.qty,
          });
        }
      });
      if (newRow?.length !== tableArr?.length) {
        toast.error(
          `${_t(t("Please select required dropdown"))}`,
          common_toast
        );
        return;
      }
      if(duplicateItem?.length){
        toast.error(`${_t(t(`Duplicate item ${duplicateItem[0].item_name} found`))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return;
      }
      let formData = {
        document_date: getDate(newGatePass?.documentDate),
        taker_name: newGatePass?.taker_name,
        branch_id: newGatePass?.branch?.id,
        branch_name: newGatePass.branch?.name,
        type: newGatePass.type,
        items: tableArr,
        remarks: newGatePass.remarks,
      };

      gatePassAxios(formData);
    } else {
      toast.error(
        `${_t(t("Please fill all the required fields"))}`,
        common_toast
      );
    }
  };

  const handleDltHandler = (id) => {
    let row = [...newRow];
    if (id > -1) {
      row.splice(id, 1);
      setNewRow(row);
    }
  };

  const addNewRow = () => {
    setNewRow((pre) => [
      ...pre,
      {
        item_name: "",
        qty: "",
        isEdit: false,
      },
    ]);
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Gate Pass"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    <CustomSpinLoader loading={loading}/>
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(
                                  t(id ? "Gate Pass Update" : "Gate Pass Add")
                                )}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7">
                          <div className="row gx-3 align-items-center"></div>
                        </div>
                      </div>

                      {/* Form starts here */}
                      <form
                        className="row card p-2 mx-3 mb-5 table-text"
                        onSubmit={handleSubmit}
                      >
                        <div className="col-12">
                          {/* master fields */}
                          <div className="row">
                            <div className="form-group col-3 mt-3">
                              <div className="mb-2">
                                <label
                                  htmlFor="document no"
                                  className="control-label"
                                >
                                  {_t(t("Document no"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="mb-2">
                                <input
                                  readOnly
                                  type="text "
                                  className="form-control table-text"
                                  id="document_no"
                                  name="document_no"
                                  placeholder="Auto no"
                                  value={newGatePass.identity}
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-group col-3 text-right mt-3">
                              <div className="mb-2 text-left">
                                <label
                                  htmlFor="document_date"
                                  className="control-label"
                                >
                                  {_t(t("Document Date"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <div className="mb-2">
                                <DatePicker
                                  selected={newGatePass.documentDate || ""}
                                  onChange={(e) =>
                                    setNewGatePass({
                                      ...newGatePass,
                                      documentDate: e,
                                    })
                                  }
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control table-text"
                                  placeholderText={_t(t("document date"))}
                                  shouldCloseOnSelect={false}
                                />
                              </div>
                            </div>

                            <div className="form-group mt-3 col-3">
                              <div className="mb-2">
                                <label
                                  htmlFor="branch"
                                  className="control-label"
                                >
                                  {_t(t("Branch"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <Select
                                options={branchSearch ? branchSearch : []}
                                components={makeAnimated()}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                value={newGatePass.branch || null}
                                classNamePrefix="select"
                                onChange={handleSetBranch}
                                maxMenuHeight="200px"
                                styles={customStyle}
                                placeholder={
                                  _t(t("Please select a branch")) + ".."
                                }
                              />
                            </div>
                            <div className="form-group mt-3 col-3">
                              <div className="mb-2">
                                <label
                                  htmlFor="taker"
                                  className="control-label"
                                >
                                  {_t(t("Taker Name"))}
                                  <span className="text-danger">*</span>
                                </label>
                              </div>
                              <input
                                id="taker"
                                class="form-control table-text rounded-25"
                                type="text"
                                name="taker_name"
                                required
                                value={newGatePass.taker_name}
                                onChange={(e) => handleSetPass(e)}
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="form-group mt-4 col-3 d-flex align-items-center">
                              <div className="d-inline mr-3 d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="form-check-input pointer-cursor"
                                  id="temporary"
                                  name="type"
                                  value="temporary"
                                  onChange={(e) => {
                                    handleSetPass(e);
                                  }}
                                  checked={newGatePass.type === "temporary"}
                                />
                                <label
                                  className="form-radio-label pointer-cursor ml-2 pt-1"
                                  htmlFor="temporary"
                                >
                                  {_t(t("Temporary"))}
                                </label>
                              </div>

                              <div className="form-check d-inline mr-2 d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="form-check-input pointer-cursor"
                                  id="permanent"
                                  name="type"
                                  value="permanent"
                                  onChange={(e) => {
                                    handleSetPass(e);
                                  }}
                                  checked={newGatePass.type === "permanent"}
                                />
                                <label
                                  className="form-radio-label pointer-cursor ml-2 pt-1"
                                  htmlFor="permanent"
                                >
                                  {_t(t("Permanent"))}
                                </label>
                              </div>
                            </div>

                            <div className="form-group mt-2 col-9">
                              <label
                                className="mb-2 control-label"
                                htmlFor="remarks"
                              >
                                {_t(t("Remarks"))}
                              </label>

                              <input
                                type="text"
                                className="form-control table-text"
                                id="remarks"
                                name="remarks"
                                onChange={(e) => handleSetPass(e)}
                                value={newGatePass.remarks}
                                placeholder="Remarks"
                              />
                            </div>
                          </div>

                          <div
                            className={`table-responsive mt-5`}
                            style={{ maxHeight: "20rem", overflow: "auto" }}
                          >
                            <table className="table table-bordered-sm table-hover">
                              <thead className="align-middle">
                                <tr>
                                  {newRow.length == 0 ? (
                                    <th
                                      scope="col"
                                      className="table-text text-capitalize align-middle text-center border-1 border"
                                    >
                                      <span
                                        className="t-mr-10"
                                        onClick={() => addNewRow()}
                                      >
                                        <i
                                          className="fa fa-plus-circle cursor-pointer btn-add-icon"
                                          style={{ fontSize: "22px" }}
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    </th>
                                  ) : (
                                    <th
                                      style={{ borderBottomColor: "lightgray" }}
                                    ></th>
                                  )}
                                  <th
                                    scope="col"
                                    className="table-text text-capitalize align-middle text-center border-1 border"
                                    style={{ width: "35rem" }}
                                  >
                                    <span style={{ fontWeight: 500 }}>
                                      {_t(t("Item"))}
                                    </span>
                                  </th>

                                  <th
                                    scope="col"
                                    className="table-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    <span style={{ fontWeight: 500 }}>
                                      {_t(t("Qty"))}
                                    </span>
                                  </th>
                                </tr>
                              </thead>
                              {newRow && newRow.length > 0 ? (
                                <tbody className="align-middle">
                                  {newRow.map((item, index) => {
                                    return (
                                      <tr className="align-middle" key={index}>
                                        <td
                                          className="table-text text-capitalize align-middle text-center table-firstChild"
                                          style={{ minWidth: "60px" }}
                                        >
                                          {index == newRow.length - 1 && (
                                            <span
                                              className="t-mr-10"
                                              onClick={() => addNewRow()}
                                            >
                                              <i
                                                className="fa fa-plus-circle btn-add-icon"
                                                style={{ fontSize: "22px" }}
                                                aria-hidden="true"
                                              ></i>
                                            </span>
                                          )}
                                          &nbsp;
                                          <i
                                            className="fa fa-minus-circle cursor-pointer text-danger"
                                            style={{ fontSize: "22px" }}
                                            onClick={() => {
                                              handleDltHandler(index);
                                            }}
                                          ></i>
                                        </td>
                                        {item?.isEdit ? (
                                          <td className="table-text text-capitalize align-middle text-center">
                                            {item.item_name}
                                          </td>
                                        ) : (
                                          <Select
                                            options={
                                              ingredientItemForSearch
                                                ? ingredientItemForSearch
                                                : []
                                            }
                                            components={makeAnimated()}
                                            getOptionLabel={(option) =>
                                              option.name
                                            }
                                            getOptionValue={(option) =>
                                              option.id
                                            }
                                            classNamePrefix="select"
                                            onChange={(e) =>
                                              handleSetItems(index, e)
                                            }
                                            value={item.item_name}
                                            styles={customStyle}
                                            menuPosition="fixed"
                                            className="bank-table-input text-center"
                                            placeholder={
                                              _t(t("Please select items")) +
                                              ".."
                                            }
                                          />
                                        )}
                                        <td className="table-text text-capitalize align-middle text-center">
                                          <input
                                            type="number"
                                            step="0.1"
                                            min="0"
                                            onKeyDown={(evt) =>
                                              [
                                                "e",
                                                "E",
                                                "+",
                                                "-",
                                                "ArrowUp",
                                                "ArrowDown",
                                              ].includes(evt.key) &&
                                              evt.preventDefault()
                                            }
                                            onWheel={(e) => e.target.blur()}
                                            className="form-control text-center table-Input table-text"
                                            id={index}
                                            name={index}
                                            onChange={(e) =>
                                              handleQty(index, e)
                                            }
                                            value={item.qty || ""}
                                            placeholder="Qty"
                                            required
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              ) : null}
                            </table>
                          </div>

                          <div className="form-group mt-4 pb-2">
                            <div className="d-flex justify-content-end align-items-center">
                              <div className="col-3 d-flex justify-content-end">
                                <button
                                  type="button"
                                  className="btn rounded hov-btn mr-3"
                                  onClick={() =>
                                    history.push(
                                      "/dashboard/manage/stock/gate-pass"
                                    )
                                  }
                                >
                                  <i
                                    class="fa fa-arrow-left"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Back"))}
                                </button>
                                <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded"
                                >
                                  <i
                                    class="fa fa-floppy-o"
                                    aria-hidden="true"
                                  ></i>{" "}
                                  {_t(t("Save"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default GatePassAction;
